import { useCallback, useEffect, useState } from 'react';
import { GetChangelogEntriesAPI } from '../../api/PublicChangelogAPI';

// Um único carregamento por sessão (mesmo padrão de useTutorialChapters)
let entriesPromise = null;

const loadEntries = () => {
  if (!entriesPromise) {
    entriesPromise = new Promise((resolve, reject) => {
      GetChangelogEntriesAPI((response) => {
        if (response && response.success) resolve(response.entries);
        else reject(new Error(response?.error || 'Erro ao carregar as novidades.'));
      });
    }).catch((err) => {
      entriesPromise = null;
      throw err;
    });
  }
  return entriesPromise;
};

/**
 * Novidades publicadas, lidas do catálogo no banco (public/changelog/entries.php):
 * entries: [{ id, date, type, title, summary, area, link, cta, plan, highlight, image, video }],
 * com image e video já como URLs prontas para o navegador.
 * @returns {{ entries: Array, loading: Boolean, error: Boolean, reload: Function }}
 */
const useChangelog = () => {
  const [state, setState] = useState({ entries: [], loading: true, error: false });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setState((prev) => (prev.loading ? prev : { ...prev, loading: true, error: false }));
    loadEntries()
      .then((entries) => active && setState({ entries, loading: false, error: false }))
      .catch(() => active && setState({ entries: [], loading: false, error: true }));
    return () => { active = false; };
  }, [attempt]);

  // Depois de um erro a promessa em cache já foi descartada: tentar de novo busca a lista outra vez
  const reload = useCallback(() => setAttempt((n) => n + 1), []);

  return { ...state, reload };
};

export default useChangelog;
